import http from '../plugins/axios';
export async function getDrivers(payload) {
  const response = await http.get('g/DRIVER', { params: payload });
  return response.data;
}

export async function assignDriver(payload) {
  const response = await http.post('cashier/assign-driver', payload);
  return response.data;
}


 
